'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Dictionary = require('./classes/Dictionary');

var _Dictionary2 = _interopRequireDefault(_Dictionary);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = new _Dictionary2.default({
  US_DOLLAR: 'US Dollar',
  EURO: 'Euro',
  POUND: 'Pound Sterling',
  JAPANESE_YEN: 'Japanese Yen',
  CHINESE_YUAN: 'Chinese Yuan',
  SWISS_FRANC: 'Swiss Franc',
  CANADIAN_DOLLAR: 'Canadian Dollar',
  AUSTRALIAN_DOLLAR: 'Australian Dollar',
  CRYPTOCURRENCY: 'Cryptocurrency',
  OTHER: 'Others'
});